import { render, staticRenderFns } from "./PaycheckPeriodMarker.vue?vue&type=template&id=013756a0&scoped=true&"
import script from "./PaycheckPeriodMarker.vue?vue&type=script&lang=ts&"
export * from "./PaycheckPeriodMarker.vue?vue&type=script&lang=ts&"
import style0 from "./PaycheckPeriodMarker.vue?vue&type=style&index=0&id=013756a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013756a0",
  null
  
)

export default component.exports